{
  "DE": "Germania",
  "AT": "Austria",
  "BE": "Belgio",
  "DK": "Danimarca",
  "ES": "Spagna",
  "FR": "Francia",
  "IE": "Irlanda",
  "IT": "Italia",
  "LU": "Lussemburgo",
  "MC": "Monaco",
  "NL": "Paesi Bassi",
  "PL": "Polonia",
  "PT": "Portogallo",
  "SE": "Svezia"
}
